import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  RoomObjectActionListItemDTO,
  TriggersAndConditionsRoomItemDTO,
  TriggersAndConditionsRoomObjectItemDTO,
  SceneActionListItemDTO,
} from '@/../client-generator/generated-clients/plants';

import {
  getRoomIconFromType,
  getSceneObjectIconFromType,
} from '@/core/utils/utils';

@Options({
  name: 'RoomObjects',
  props: {
    room: {
      required: true,
      type: Object as PropType<any>,
    },
  },
  emits: ['add-object'],
})
export default class RoomObjects extends Vue {
  getRoomIconFromType = getRoomIconFromType;
  getSceneObjectIconFromType = getSceneObjectIconFromType;

  room!: RoomObjectActionListItemDTO | TriggersAndConditionsRoomItemDTO;
  isExpanded = false;

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  handleAddObject(object: SceneActionListItemDTO | TriggersAndConditionsRoomObjectItemDTO) {
    this.$emit('add-object', object);
  }
}
